<template>
  <ErrorBoundary>
    <div class="flex flex-col justify-between">
      <label class="text-sm font-medium">
        {{ t('product.show.checkout.time') }}
      </label>
      <div
        class="flex flex-wrap mt-2 gap-2"
        :class="{
          'max-h-20 overflow-hidden': isCollapsed,
          'max-h-32 overflow-scroll': !isCollapsed,
        }"
      >
        <Chip
          v-for="date in eventDatesForSelectedDay"
          :key="date.id"
          classes="m-0 text-sm p-1.5 px-2"
          :selected="eventDateChipModel?.id === date.id"
          @click="eventDateChipModel = date"
        >
          <div class="flex justify-between items-center gap-1">
            <div class="ml-1">{{ getDateTime(date) }}</div>
            <EventBuyBoxTimeSlotsBadge
              v-if="eventDatesForSelectedDay.length === 1"
              :date="date"
            />
          </div>
        </Chip>
      </div>
      <Chip
        v-show="eventDatesForSelectedDay?.length > 6"
        classes="py-2 mt-2 mb-0 w-fit h-fit text-sm"
        @click="isCollapsed = !isCollapsed"
        >{{ isCollapsed ? t('general.more') : t('general.less') }}
      </Chip>
    </div>
  </ErrorBoundary>
</template>
<script setup lang="ts">
import { getDateTime } from '../../../composables/useEventDateHelpers'
import type { EventCalendarDay, EventDate } from '~/composables/types/event'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    selectedDay: EventCalendarDay | undefined
  }>(),
  {
    selectedDay: undefined,
  }
)

const eventDateChipModel = defineModel<EventDate | undefined>(undefined)

const eventDatesForSelectedDay = computed<EventDate[]>(() => {
  return (
    props.selectedDay?.dates?.filter((date) =>
      eventDateGetters.getDateIsOpen(date)
    ) || []
  )
})

const isCollapsed = ref(true)
</script>
